import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';

@Component({
  selector: 'weekday-dropdown',
  templateUrl: './weekday-dropdown.component.html',
  styleUrls: ['./weekday-dropdown.component.scss'],
  standalone: false,
})
export class WeekdayDropdownComponent {
  private readonly elementRef = inject(ElementRef<HTMLElement>);

  @Input() weekday: number;
  @Output() weekdayChange: EventEmitter<number> = new EventEmitter<number>();

  constructor() {}

  /** A parent fieldset disables the native control; mat-select does not inherit that. */
  get disabledByFieldset(): boolean {
    const fieldset = this.elementRef.nativeElement.closest('fieldset');

    return fieldset instanceof HTMLFieldSetElement && fieldset.disabled;
  }

  emitValue() {
    this.weekdayChange.emit(this.weekday);
  }
}
